import { render, staticRenderFns } from "./EventTypesPage.html?vue&type=template&id=0ebd3f14&"
import script from "./EventTypesPage.ts?vue&type=script&lang=ts&"
export * from "./EventTypesPage.ts?vue&type=script&lang=ts&"
import style0 from "./EventTypesPage.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VRow})
